import * as itemTypeConstants from "../../../../constants/itemTypeConstants";
import * as modalTypes from "../../../../constants/modalTypes";
import * as objectTypes from "../../../../constants/objectTypes";
import * as optionHelper from "../../../../helpers/optionHelper";
import * as propertyConstants from "../../../../constants/propertyConstants";
import * as translationHelper from "../../../../helpers/translationHelper";

import { Barcode, generateBarcodeData, generateBarcodeHeadings, generateBarcodeTypes } from "../../../../types/barcode";
import React, { Component } from "react";

import { ModalParams } from "../../../../types/modalParams";
import { ModalProperties } from "../../../../types/modalProperties";
import { System } from "../../../../types/system";
import { SystemZone } from "../../../../types/systemZone";
import { TableContainer } from "../../../Table";
import { TableHeading } from "../../../../types/tableHeading";
import { t as translate } from "react-i18nify";

type Props = {
    tableConstant: string;
    objectType: objectTypes.ObjectType;
    dataPrivileges: any;
    loading: boolean;
    allList: Array<Barcode>;
    activeList: Array<Barcode>;
    systemList: Array<System>;
    zoneList: Array<SystemZone>;
    columnOrder: Array<propertyConstants.Property>;
    columnVisibility: Record<propertyConstants.Property, boolean>;
    columnWidth: Record<propertyConstants.Property, number>;
    offset: number;
    page: number;
    rowCount: number;
    rowCountCustom: boolean;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    showFilterRow: boolean;
    showGlobalSearch: boolean;
    sortingAsc: boolean;
    sortingCriterion: propertyConstants.Property | null;
    totalCount: number | null;
};

export class BarcodeTable extends Component<Props> {
    generateTableHeadings = (modalType: modalTypes.ModalType | null = null): Array<TableHeading> => {
        const propertyList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_BARCODE,
            propertyConstants.PROPERTY_SYSTEM_ID,
            propertyConstants.PROPERTY_ZONE_ID
        ];
        const alwaysVisibleList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_BARCODE];
        const editableList: Array<propertyConstants.Property> = [];
        let requiredList: Array<propertyConstants.Property> = [...propertyList];
        let visibleList: Array<propertyConstants.Property> = [...propertyList];

        if (modalType !== null && this.props.activeList.length) {
            requiredList = [];

            switch (this.props.activeList[0][propertyConstants.PROPERTY_ITEM_TYPE_ID]) {
                case itemTypeConstants.ITEM_TYPE_BASE_IN_PRODUCT_PACKAGE: {
                    visibleList.splice(3, 0, propertyConstants.PROPERTY_PACKAGE_NAME);
                    visibleList.splice(3, 0, propertyConstants.PROPERTY_BASE_NAME);
                    visibleList.splice(3, 0, propertyConstants.PROPERTY_PRODUCT_NAME);
                    break;
                }
                case itemTypeConstants.ITEM_TYPE_COLOR_IN_FANDECK: {
                    visibleList.splice(3, 0, propertyConstants.PROPERTY_COLOR_NAME);
                    visibleList.splice(3, 0, propertyConstants.PROPERTY_FANDECK_NAME);
                    break;
                }
                case itemTypeConstants.ITEM_TYPE_COLORANT_PACKAGE: {
                    visibleList.splice(3, 0, propertyConstants.PROPERTY_PACKAGE_NAME);
                    visibleList.splice(3, 0, propertyConstants.PROPERTY_COLORANT_NAME);
                    break;
                }
                case itemTypeConstants.ITEM_TYPE_FANDECK: {
                    visibleList.splice(3, 0, propertyConstants.PROPERTY_FANDECK_NAME);
                    break;
                }
                default:
                    break;
            }
        }

        let orderList = [...visibleList];

        if (modalType === null) {
            visibleList.splice(1, 0, propertyConstants.PROPERTY_ITEM_TYPE_ID);

            orderList = optionHelper.handleTableHeadingOrder(visibleList, this.props.columnOrder);
            visibleList = optionHelper.handleTableHeadingVisibility(visibleList, this.props.columnVisibility);
        }

        return generateBarcodeHeadings(
            this.props.objectType,
            generateBarcodeTypes(),
            this.props.systemList,
            this.props.zoneList,
            orderList,
            visibleList,
            editableList,
            requiredList,
            alwaysVisibleList,
            this.props.columnWidth
        );
    };

    generateEditModalParams = (): ModalParams | null => {
        const activeData = generateBarcodeData(this.props.activeList);

        if (activeData.length) {
            return new ModalParams(
                modalTypes.EDIT_MODAL,
                this.props.objectType,
                translate("barcode.barcode"),
                activeData[0],
                this.generateTableHeadings(modalTypes.MODAL_BARCODE_EDIT)
            );
        }

        return null;
    };

    render(): JSX.Element {
        const modalProperties: ModalProperties = {
            editModalType: modalTypes.MODAL_BARCODE_EDIT,
            editModalParams: this.generateEditModalParams()
        };

        return (
            <div className="height-100">
                <TableContainer
                    className={"table-with-filter"}
                    tableConstant={this.props.tableConstant}
                    objectType={this.props.objectType}
                    dataPrivileges={this.props.dataPrivileges}
                    loading={this.props.loading}
                    title={translationHelper.getTitleSectionTranslation(this.props.objectType)}
                    titleClassName={"main-title"}
                    headings={this.generateTableHeadings()}
                    data={generateBarcodeData(this.props.allList)}
                    activeData={this.props.activeList}
                    offset={this.props.offset}
                    page={this.props.page}
                    rowCount={this.props.rowCount}
                    rowCountCustom={this.props.rowCountCustom}
                    search={this.props.search}
                    searchParams={this.props.searchParams}
                    showFilterRow={this.props.showFilterRow}
                    showGlobalSearch={this.props.showGlobalSearch}
                    sortingAsc={this.props.sortingAsc}
                    sortingCriterion={this.props.sortingCriterion}
                    totalCount={this.props.totalCount}
                    modalProperties={modalProperties}
                />
            </div>
        );
    }
}
